// extracted by mini-css-extract-plugin
export default {"wrapper":"cookieBannerContent_wrapper"};